const ArrowRight = () => (
    <svg
        width='11'
        height='6'
        viewBox='0 0 11 6'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='arrow-right'
    >
        <path
            d='M10.3665 3L5.36645 0.113248L5.36646 5.88675L10.3665 3ZM0.57373 3.5L5.86646 3.5L5.86646 2.5L0.57373 2.5L0.57373 3.5Z'
            fill='white'
        />
    </svg>
);

export default ArrowRight;
